if (!customElements.get('redefine-memberships')) customElements.define('redefine-memberships', class extends HTMLElement {
 connectedCallback(){this.frame=requestAnimationFrame(()=>this.init());}
 init(){
  if(!this.isConnected)return;
  this.controller=new AbortController();const signal=this.controller.signal;
  const reduced=matchMedia('(prefers-reduced-motion: reduce)');
  const animated=()=>this.dataset.animate==='true'&&!reduced.matches;
  const floatCards=()=>{
   if(this.scrollFrame)return;
   this.scrollFrame=requestAnimationFrame(()=>{
    this.scrollFrame=null;
    const tiers=this.querySelector('.rcTiers');if(!tiers)return;
    const r=tiers.getBoundingClientRect();
    const f=animated()?Math.max(-1,Math.min(1,(r.top+r.height/2-innerHeight/2)/(innerHeight/2))):0;
    this.querySelectorAll('.rcCard').forEach(c=>c.style.setProperty('--f',String(f)));
   });
  };
  window.addEventListener('scroll',floatCards,{passive:true,signal});
  window.addEventListener('resize',floatCards,{signal});
  reduced.addEventListener('change',floatCards,{signal});
  floatCards();
  if(animated()&&'IntersectionObserver' in window){
   this.classList.add('is-ready');
   this.observer=new IntersectionObserver(entries=>entries.forEach(e=>{if(e.isIntersecting){e.target.classList.add('is-in');this.observer.unobserve(e.target);}}),{rootMargin:'0px 0px -10% 0px'});
   this.querySelectorAll('[data-reveal]').forEach(e=>this.observer.observe(e));
  }
  const reveal=()=>this.querySelectorAll('[data-reveal]').forEach(e=>e.classList.add('is-in'));
  this.addEventListener('focusin',reveal,{signal});this.addEventListener('shopify:block:select',reveal,{signal});
  this.querySelectorAll('.rcCard').forEach(card=>{
   const reset=()=>{card.classList.remove('is-tilting');card.style.setProperty('--rx','0deg');card.style.setProperty('--ry','0deg');};
   card.addEventListener('pointermove',e=>{if(e.pointerType!=='mouse'||!animated())return;const r=card.getBoundingClientRect();card.classList.add('is-tilting');card.style.setProperty('--ry',`${((e.clientX-r.left)/r.width-.5)*16}deg`);card.style.setProperty('--rx',`${-((e.clientY-r.top)/r.height-.5)*12}deg`);},{signal});
   card.addEventListener('pointerleave',reset,{signal});
   card.addEventListener('click',()=>{const on=card.getAttribute('aria-pressed')!=='true';card.setAttribute('aria-pressed',String(on));card.querySelector('.rcCard__f').setAttribute('aria-hidden',String(on));card.querySelector('.rcCard__b').setAttribute('aria-hidden',String(!on));reset();},{signal});
   card.addEventListener('transitionend',e=>{if(e.target===card&&e.propertyName==='transform')card.classList.add('is-dealt');},{signal});
  });
 }
 disconnectedCallback(){cancelAnimationFrame(this.frame);cancelAnimationFrame(this.scrollFrame);this.scrollFrame=null;this.controller?.abort();this.observer?.disconnect();this.classList.remove('is-ready');this.querySelectorAll('.is-in').forEach(e=>e.classList.remove('is-in'));}
});
